import { createSignal } from '@verclam/pulsar';

/**
 * Two mutually exclusive modes for the same panel. A `documentTypeId` carried as an optional field
 * next to `mode` would let `{ mode: 'create', documentTypeId: 5 }` type-check while making no sense:
 * the discriminated union rules it out entirely.
 */
export type DocumentTypeSidebarContext =
	| { readonly mode: 'create' }
	| { readonly mode: 'rename'; readonly documentTypeId: number };

const documentTypeSidebarSignal = createSignal<DocumentTypeSidebarContext | null>(null);

export const openDocumentTypeSidebarForCreation = (): void => {
	documentTypeSidebarSignal.value = { mode: 'create' };
};

export const openDocumentTypeSidebarForRename = (documentTypeId: number): void => {
	documentTypeSidebarSignal.value = { mode: 'rename', documentTypeId };
};

export const closeDocumentTypeSidebar = (): void => {
	documentTypeSidebarSignal.value = null;
};

export default documentTypeSidebarSignal;
